<exg-modal></exg-modal>
<exg-overlay></exg-overlay>

<ng-container *ngFor="let o of childs">
  <ng-container *ngTemplateOutlet="o"></ng-container>
</ng-container>
<div #child></div>
<ng-template #appLinkContainer >
	<div  class="stack-center splash-content">
		<div class="link-container">
			<a href="https://www.excon.com">{{getResource('Footer.Home')}}</a>
			<a href="https://www.excon.com/kontaktformular">{{getResource('Footer.Contact')}}</a>
			<a href="https://www.excon.com/unternehmen/impressum">{{getResource('Footer.Imprint')}}</a>
			<a href="https://www.excon.com/datenschutzerklaerung">{{getResource('Footer.DataProtection')}}</a>
		</div>
		<div class="copyright">{{getResource('Footer.Copyright')}}</div>
		<div class="app-content-svg-logo" style="width: 97px;height: 2.5rem;"> </div>
	</div>
</ng-template>
<ng-template #appText>
  <div class="app-header-apptitle">
    <div>{{title}}</div>
  </div>
</ng-template>
<exg-signin-ui #signInRoot>
	<ng-template #signInDialog>
		<div class="layout-auto-1-auto app-splash">
			<div class="app-header app-content-svg-logo spawn">
				<div class="app-header-apptitle">
					<div>{{title}}</div>
				</div>
			</div>
			<div class="content ">
				<exg-default-signin-dialog [parent]="signInRoot"></exg-default-signin-dialog>
			</div>
			<ng-container *ngTemplateOutlet="appLinkContainer"></ng-container>
		</div>
	</ng-template>
	<ng-template #forgottenPasswordDialog>
		<div class="layout-auto-1-auto app-splash">
			<div class="app-header app-content-svg-logo">
				<div class="app-header-apptitle">
					<div>{{title}}</div>
				</div>
			</div>
			<div class="content ">
				<exg-default-password-forgotten-dialog [parent]="signInRoot"></exg-default-password-forgotten-dialog>
			</div>
			<ng-container *ngTemplateOutlet="appLinkContainer"></ng-container>
		</div>
	</ng-template>
	<ng-template #changePasswordDialog>
		<div class="layout-auto-1-auto app-splash">
			<div class="app-header app-content-svg-logo">
				<div class="app-header-apptitle">
					<div>{{title}}</div>
				</div>
			</div>
			<div class="content">
				<exg-default-change-password-dialog></exg-default-change-password-dialog>
			</div>
			<ng-container *ngTemplateOutlet="appLinkContainer"></ng-container>
		</div>
	</ng-template>
  <ng-template #signInContent>
    <div class="layout-auto-1-auto-grid-auto-1-auto">
      <div class="app-header app-content-svg-logo span-layout spawn-reverse">
        <ng-container *ngTemplateOutlet="appText"></ng-container>
        <div class="app-top-header "><!--<span class="version">(Version: 26.1008.220009)</span>-->
          <span class="app-env-badge"
                *ngIf="isDev">
	          {{getRessource('Environment')}}
          </span>
          <span class="app-env-badge"
                style="background: var(--c-yellow-500)"
                *ngIf="isQs">
	          {{getRessource('EnvironmentQS')}}
          </span>
        </div>
        <div class="app-top-header right">
	        <ng-container *ngIf="excSecurity.isFeatured('GLOBALSEARCHUSE')">
		        <app-searchbar #VCGlobalSearch
		                       [placeholder]="getRessource('GlobalSearch.Placeholder')"
		                       [searchOnEnter]="true"

		                       [iconClass]="'fal fa-nfc-magnifying-glass'"
		                       [inputStyle]="'padding: 2px 32px 2px 40px;'"
		                       [inputDelay]="500"

		                       (search)="globalSearch($event)"
		                       (searchReset)="searchResult.resetSearch()"

		                       (focusin)="searchResult.showResult()"
		                       (focusout)="searchResult.hideResult()"
		                       style="width: 540px">
		        </app-searchbar>
		        <div class="app-global-search-result layout-auto-1-auto"
		             *ngIf="searchResult.showResults">
			        <div *ngIf="searchResult.data.length === 0 && !searchResult.isLoading"
			             class="typo-small app-ghost-row">
				        {{getResource('GlobalSearch.isEmpty')}}
			        </div>
			        <div *ngIf="searchResult.data.length === 0 && searchResult.isLoading"
			             class="typo-small app-ghost-row">
				        {{getResource('GlobalSearch.isLoading')}}
			        </div>
			        <div *ngIf="searchResult.data.length > 0"></div>
			        <div class="content">
				        <div *ngFor="let sr of searchResult.data"
				             class="list-row grid-auto-1 typo-small app-cursor-pointer"
				             style="padding: 0.25rem 0.75rem; line-height: 1.6"
				             (click)="openSearchResult(sr)">
					        <div class="list-avatar nobackground">
						        <i class="fa-xl"
						           *ngIf="sr.vorgID"
						           [class]="getTranslation('Icons.Task')"></i>
						        <i class="fa-xl"
						           *ngIf="sr.auID && !sr.vorgID"
						           [class]="getTranslation('Icons.Case')"></i>
					        </div>
					        <div class="grid-auto-1-auto">
					        <span>
						        {{ sr.auNr }}
					        </span>
						        <span style="padding: 0 .25rem">
						        {{ sr.auAuftraggeberShort }}
					        </span>
						        <span class="typo-right">
						        {{ sr.aueSchadenNr }}
					        </span>
						        <span class="app-list-row-tiny app-list-row-secondary">
						        {{ sr.vorgNr }}
					        </span>
						        <span class="app-list-row-tiny app-list-row-secondary"
						              style="padding: 0 .25rem">
						        {{ sr.Versicherungsnehmer_Name && sr.Versicherungsnehmer_Name.length > 0 && sr.Versicherungsnehmer_Vorname && sr.Versicherungsnehmer_Vorname.length > 0 ? sr.Versicherungsnehmer_Name + ', ' : sr.Versicherungsnehmer_Name }}{{sr.Versicherungsnehmer_Vorname}}
					        </span>
						        <span class="app-list-row-tiny app-list-row-secondary typo-right">
						        {{ sr.aueSchadenort_Plz }} {{ sr.aueSchadenort_Ort }} {{ sr.aueSchadenort_Strasse }} {{ sr.aueSchadenort_HausNr }}
					        </span>
					        </div>
				        </div>
			        </div>
			        <div class="typo-small app-ghost-row typo-center app-cursor-pointer"
			             *ngIf="searchResult.searchValue.length > 0 && !searchResult.isLoading"
			             (click)="searchMode()"
			             style="margin-top: .25rem; padding-top: .25rem; color: var(--c-ctrl-border); opacity: 1;">
				        {{searchResult.mode === 0 ? getResource('GlobalSearch.SearchOld') : getResource('GlobalSearch.SearchNew')}}
			        </div>
			        <ng-container *ngIf="searchResult.recentSearch.length > 0 && !searchResult.isLoading">
				        <div class="typo-small app-ghost-row"
				             style="margin-top: .25rem; padding-top: .25rem; border-top: 1px solid var(--c-dark-m2)">
					        {{getResource('GlobalSearch.RecentSearch')}}
				        </div>
				        <div *ngFor="let recentSearch of searchResult.getRecentSearches()"
				             class="list-row grid-auto-1 typo-small app-cursor-pointer"
				             style="padding: 0.25rem 0.75rem; line-height: 1.3"
				             (click)="searchRecent(recentSearch)">
					        <div>
						        {{ recentSearch }}
					        </div>
				        </div>
			        </ng-container>
		        </div>
	        </ng-container>
	        <div>
	          <a class="app-nav-top-element" (click)="openTextvorlagenMenu($event)">
	            <i class="far fa-align-left"></i>
	          </a>
	          <exg-popup #VCTextvorlagenMenu [closeAlways]="true">
	            <div class="md-menu content app-menu-textvorlagen">
	              <div style="padding: 0 0.75rem; border-bottom: 1px solid var(--c-dark-m2); line-height: 1.3">
	                <strong class="typo-small">{{getResource('UserSettings.Title')}}</strong>
	              </div>
	              <div *ngIf="userSettings.textvorlagen.length === 0"
	                   class="typo-small app-ghost-row">
	                   {{getResource('UserSettings.Description')}}
	              </div>
	              <div *ngFor="let tv of userSettings.textvorlagen"
	                   class="list-row typo-small app-cursor-pointer"
	                   style="padding: 0.25rem 0.75rem; line-height: 1.6"
	                   (click)="copyTextvorlage(tv)">
	                <div class="app-list-row-tiny">
	                  {{ tv.tbName }}
	                </div>
	                <div class="app-list-row-tiny app-list-row-secondary">
	                  {{ tv.tbTextShort }}
	                </div>
	              </div>
	            </div>
	          </exg-popup>
          </div>
          <a class="app-nav-top-element" (click)="openMenu($event)">
            <i class="fas fa-bars"></i>
          </a>
        </div>
      </div>
      <exg-popup #VCBurgerMenu [closeAlways]="false">
        <div class="md-menu content" style="width: 360px">
          <div class="layout-auto-1-auto">
            <div class="grid-auto-1 app-margin-small">
              <img class="user_avatar__medium" [src]='userData?.idProfilePicture || defaultProfilePicture'>
              <div>
              <p style="margin-top: 0">
                <strong>{{excSecurity.UserName}}</strong>
                <em class="typo-small">{{excSecurity.UserLogin}}</em>
              </p>
              <app-exg-dropdown *ngIf="getParallelLogins().length !== 0">
                <ng-template #hostTemplate>
                  <p>
                  <em class="typo-small" style="color:var(--fa-primary-color)">
                    {{getGlobal("ChangeContext")}}
                    <i class="fas fa-fw fa-caret-down"></i>
                  </em>
                  </p>
                </ng-template>
                <ng-template #contentTemplate let-popup>
                  <div *ngFor="let login of getParallelLogins()" (click)="excSecurity.changeUser(login.uid);popup.close();">
                    <div class="list-row list-single-line  typo-small" style="cursor: pointer"
                    >{{login.login}}</div>
                  </div>
                </ng-template>
              </app-exg-dropdown>
              </div>
            </div>
            <div *ngIf="excSecurity.isFeatured('DEVELOPMENT')">
              <exg-select [ngModel]="langIndex" (ngModelChange)="langIndexChange($event)" [list]="language" listdisplay="text"
                          name="lang" [caption]="getGlobal('Language')" >
              </exg-select>
            </div>
            <div class="stack" style="align-items: flex-end;">
              <button class="md-btn" (click)="showSettings()">{{getResource('BurgerMenu.Settings')}}</button>
              <button class="md-btn" (click)="excSecurity.showChangePasswordDialog()">{{getGlobal('ChangePassword')}}</button>
              <!--<button class="md-btn" (click)="excSecurityService.showChangePasswordDialog()">{{getGlobal('ChangePassword')}}</button>-->
              <button class="md-btn" (click)="appLogout()">{{getGlobal('Logout')}}</button>
              <span class="app-version-number">{{getResource('BurgerMenu.Build')}}&nbsp;26.1008.220009</span>
            </div>
          </div>
        </div>
      </exg-popup>
	    <div class="content app-sidebar-wide">
		    <ng-container *ngFor="let navItem of Navigation">
			    <div routerLink="{{navItem.path}}" routerLinkActive="active" style="position:relative" *ngIf="excSecurity.isStateAvailable(navItem.path)">
				    <i [ngClass]="navItem.Icon" class="nav-icon"> </i>
				    <em>{{navItem.Caption}}</em>
            <i class="far fa-plus nav-icon-secondary" *ngIf="navItem.appTabbable" (click)="openNewTab($event, navItem)"></i>
			    </div>
		    </ng-container>
	    </div>


	    <div class="content span-2">
		    <div class="layout-auto-1">
			    <!-- <div class="app-application-tab-container">
						<div class="app-application-tab" *ngFor="let Tab of exgTabService.Tabs" [ngClass]="{'active':Tab.Active}" (click)="Tab.Select()">
							<i [ngClass]="Tab.Icon"></i>
							<span class="app-application-tab-text">{{Tab.Label}}</span>
							<i *ngIf="Tab.Closeable" (click)="Tab.Close()"class="app-application-tab-closeicon far fa-times"></i>
						</div>
					</div> --->
			    <div class="grid-1-auto">
				    <div #tabContainer class="app-application-tab-container"
                 cdkDropList
                 cdkDropListOrientation="horizontal"
                 (cdkDropListDropped)="onTabDrop($event)">
					    <ng-container *ngFor="let Tab of exgTabService.Tabs; let i = index">
						    <div *ngIf="i < maxTabs()"class="app-application-tab"
                     [ngClass]="{'active':Tab.Active, 'pinned': isTabPinned(Tab)}"
                     cdkDrag
                     [cdkDragDisabled]="i === 0"
                     (click)="Tab.Select()"
                     (auxclick)="onTabAuxClick($event, Tab)">
							    <i [ngClass]="Tab.Icon"></i>
							    <span class="app-application-tab-text">{{Tab.Label}}</span>


                  <!-- tab pinned -> nimmt close button ein wie in vscode/webstorm -->
                  <i *ngIf="i > 0 && isTabPinned(Tab)"
                     class="fas fa-thumbtack pin-icon-right"
                     (click)="toggleTabPin(Tab);
                     $event.stopPropagation()">
                  </i>


                  <!-- tab nicht -> pin button links neben close button-->
                  <ng-container *ngIf="i > 0 && !isTabPinned(Tab)">
                    <i class="fas fa-thumbtack-slash pin-icon-left"
                       (click)="toggleTabPin(Tab);
                       $event.stopPropagation()">
                    </i>

                    <i *ngIf="Tab.Closeable"
                       (click)="Tab.Close()"
                       class="app-application-tab-closeicon far fa-times">
                    </i>
                  </ng-container>
						    </div>
					    </ng-container>
				    </div>
				    <div style="background-color: var(--c-dark-600); height: 2.25rem;">
					    <ng-container *ngIf="exgTabService.Tabs.length >= (maxTabs() + 1)">
						    <i class="search-action far fa-circle-chevron-down" style="margin-top: 0.25rem" (click)="togglePopupMenu($event)"></i>
						    <exg-popup #filter [closeAlways]="false" width="360">
							    <div class="md-menu content" style="background-color: var(--c-dark-600);padding: 0.5rem 0.5rem 0.25rem 0.5rem; max-height: calc(100vh - 8.25rem);">
								    <ng-container *ngFor="let Tab of exgTabService.Tabs; let i = index">
									    <div *ngIf="i >= maxTabs()" class="app-application-tab"
									         style="height:32px; margin-right: 0; margin-bottom: 0.25rem"
									         [ngClass]="{'active':Tab.Active}" (click)="Tab.Select()" (auxclick)="onTabAuxClick($event, Tab)">
										    <i [ngClass]="Tab.Icon"></i>
										    <span class="app-application-tab-text">{{Tab.Label}}</span>

                        <i *ngIf="i > 0 && isTabPinned(Tab)"
                           class="fas fa-thumbtack pin-icon-right"
                           (click)="toggleTabPin(Tab);
                             $event.stopPropagation()">
                        </i>

                        <ng-container *ngIf="i > 0 && !isTabPinned(Tab)">
                          <i class="fas fa-thumbtack-slash pin-icon-left"
                             (click)="toggleTabPin(Tab);
                             $event.stopPropagation()">
                          </i>

                          <i *ngIf="Tab.Closeable" (click)="Tab.Close()"
                             class="app-application-tab-closeicon far fa-times"></i>

                        </ng-container>
									    </div>
								    </ng-container>
							    </div>
						    </exg-popup>
					    </ng-container>
				    </div>
			    </div>

			    <div [hidden]="!busy" class="content md3-surface">
				    <div class="splash loading">
					    <p>Anwendung wird geladen</p>
				    </div>
			    </div>

			    <div [hidden]="busy" class="content">
				    <exg-application-tab [hidden]="!exgTabService.StateTab?.Active">
					    <router-outlet></router-outlet>
				    </exg-application-tab>
				    <exg-application-tab *ngFor="let Tab of exgTabService.Tabs | slice:1, let i = index" [tabinstance]="Tab"
				                         [hidden]="!Tab.Active"></exg-application-tab>
				    <!-- Additional Application Tab Contents -->
			    </div>
		    </div>
	    </div>
      <div><!--Footer--></div>
    </div>
  </ng-template>
</exg-signin-ui>
